'use client'
import { ThemeProvider } from '@/providers/ThemeProvider'
import { QueryProvider } from '@/providers/QueryClientProvier'
import { ToastProvider } from '@/providers/ToastProvider'
import { NextIntlClientProvider, type AbstractIntlMessages } from 'next-intl'

import type { PropsWithChildren } from 'react'

type ProvidersProps = PropsWithChildren<{ locale: string; messages: AbstractIntlMessages }>

export const Providers = ({ locale, messages, children }: ProvidersProps) => (
  <NextIntlClientProvider locale={locale} messages={messages}>
    <ThemeProvider>
      <ToastProvider>
        <QueryProvider>{children}</QueryProvider>
      </ToastProvider>
    </ThemeProvider>
  </NextIntlClientProvider>
)
